"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nfcConfig = void 0;
const providers_1 = require("@mne-core/providers");
const labels_1 = require("./labels");
const nfcConfig = (user, locale) => ({
    isBeta: false,
    logo: {
        src: "resources/versions/1.5.0/images/nfcert-logo.png",
        href: "/dashboard/redirect",
    },
    nav: {
        kind: "nav",
        items: [
            {
                kind: "dropdown",
                requiredPermission: "showLogsMenu",
                iconId: "case",
                label: (0, labels_1.getLabels)(locale).CASE,
                items: [
                    {
                        kind: "internalLink",
                        requiredPermission: "useCreateCaseSPA",
                        iconId: "createCase",
                        label: (0, labels_1.getLabels)(locale).CASE_CREATE,
                        href: "case/create",
                    },
                    {
                        kind: "internalLink",
                        iconId: "none",
                        href: '/case?advancedSearch={"showClosed"%3Afalse}',
                        label: (0, labels_1.getLabels)(locale).CASE_SHOW_OPEN,
                    },
                    {
                        kind: "internalLink",
                        iconId: "none",
                        label: (0, labels_1.getLabels)(locale).CASE_SHOW_ALL,
                        href: "/case",
                    },
                ],
            },
            {
                kind: "dropdown",
                requiredPermission: "showDataMenu",
                iconId: "data",
                label: "Data",
                items: [
                    {
                        kind: "internalLink",
                        requiredPermission: "showIDSMenu",
                        iconId: "search",
                        label: (0, labels_1.getLabels)(locale).EVENT_SEARCH,
                        href: "event/search/redirect",
                    },
                    {
                        kind: "internalLink",
                        requiredPermission: "ipReputationSearch",
                        iconId: "search",
                        label: (0, labels_1.getLabels)(locale).REPUTATION_SEARCH,
                        href: "reputation/observations",
                    },
                    {
                        kind: "internalLink",
                        requiredPermission: "viewSamples",
                        iconId: "none",
                        label: (0, labels_1.getLabels)(locale).SAMPLE,
                        href: "sample",
                    },
                    {
                        kind: "internalLink",
                        requiredPermission: "viewPassiveDNS",
                        iconId: "none",
                        label: (0, labels_1.getLabels)(locale).PDNS,
                        href: "passivedns",
                    },
                    {
                        kind: "internalLink",
                        requiredPermission: "viewDataStoreDescriptors",
                        iconId: "none",
                        label: (0, labels_1.getLabels)(locale).DATASTORE,
                        href: "datastore",
                    },
                    {
                        kind: "internalLink",
                        requiredPermission: "viewDocuments",
                        iconId: "none",
                        label: (0, labels_1.getLabels)(locale).DOCUMENTS,
                        href: "document",
                    },
                    {
                        kind: "internalLink",
                        requiredPermission: "viewAssets",
                        iconId: "none",
                        label: (0, labels_1.getLabels)(locale).ASSETS,
                        href: "asset",
                    },
                    {
                        kind: "internalLink",
                        requiredPermission: "viewThreatIntelFact",
                        iconId: "none",
                        label: (0, labels_1.getLabels)(locale).TI,
                        href: "act",
                    },
                ],
            },
            {
                kind: "externalLink",
                iconId: "chat",
                label: (0, labels_1.getLabels)(locale).CHAT,
                href: "https://chat.nfcert.org/oauth/openid/login",
            },
            {
                kind: "externalLink",
                iconId: "nfcWiki",
                label: (0, labels_1.getLabels)(locale).WIKI,
                href: "https://wiki.nfcert.org",
            },
            {
                kind: "search",
                requiredPermission: "showLogsMenu",
                label: (0, labels_1.getLabels)(locale).SEARCH,
            },
        ],
    },
    userMenu: {
        kind: "userMenu",
        name: user?.name,
        imageSrc: (0, providers_1.toApiUrl)(`/users/v2/user/${user?.id}/picture`),
        items: [
            {
                kind: "internalLink",
                iconId: "adminSettings",
                label: (0, labels_1.getLabels)(locale).ADMIN,
                href: "authentication/admin",
            },
            {
                kind: "internalLink",
                iconId: "userMenu",
                label: (0, labels_1.getLabels)(locale).USER_PREFS,
                href: "user/profile",
            },
            {
                kind: "externalLink",
                iconId: "apiDocs",
                label: (0, labels_1.getLabels)(locale).DOCUMENTATION,
                href: "https://docs.mnemonic.no",
            },
            {
                kind: "internalLink",
                iconId: "externalApp",
                label: (0, labels_1.getLabels)(locale).EXT_APPS,
                href: "authentication/oauth/clients",
            },
            {
                kind: "contactUs",
                iconId: "contact",
                label: (0, labels_1.getLabels)(locale).CONTACT_US,
            },
            {
                kind: "internalLink",
                iconId: "logout",
                label: (0, labels_1.getLabels)(locale).LOGOUT,
                href: "authentication/logout",
            },
        ],
    },
});
exports.nfcConfig = nfcConfig;
